import { render, staticRenderFns } from "./VPSForgotPwdFormComponent.vue?vue&type=template&id=59c16954&scoped=true"
import script from "./VPSForgotPwdFormComponent.vue?vue&type=script&lang=js"
export * from "./VPSForgotPwdFormComponent.vue?vue&type=script&lang=js"
import style0 from "./VPSForgotPwdFormComponent.vue?vue&type=style&index=0&id=59c16954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c16954",
  null
  
)

export default component.exports